// extracted by mini-css-extract-plugin
export default {"container":"LoginAdmin_container__FCeoh","formContainer":"LoginAdmin_formContainer__XjBct","title":"LoginAdmin_title__jjQL0","button":"LoginAdmin_button__FM8AS"};